function getCategoryIcon(url, fillColor = "#ffffff") {
  const isSvg = url.toLowerCase().endsWith(".svg");

  if (isSvg) {
    // Handle SVG via fetch
    return fetch(`https://dev.app.pikilinks.com/wp-json/ng/v1/svg?url=${url}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch SVG: ${response.status}`);
        }
        return response.text();
      })
      .then((svgText) => {
        // STEP 1: Trim and fix any escaped characters
        svgText = svgText.trim();

        // Some servers escape forward slashes, which is unnecessary
        svgText = svgText.replace(/\\\//g, "/");

        // Optional: remove escaped quotes if response is double-encoded
        if (svgText.startsWith('"') && svgText.endsWith('"')) {
          svgText = svgText.slice(1, -1);
          svgText = svgText.replace(/\\"/g, '"');
        }

        const parser = new DOMParser();
        const doc = parser.parseFromString(svgText, "image/svg+xml");
        const svg = doc.documentElement;

        svg.setAttribute("fill", fillColor);

        svg.setAttribute("width", "25");
        svg.setAttribute("height", "25");

        return svg;
      });
  } else {
    // Handle PNG/JPG via <img src>
    const img = document.createElement("img");
    img.src = url;
    img.alt = "icon";
    img.width = 25;
    img.height = 25;
    return Promise.resolve(img);
  }
}

function updateCategoryIconColor(icon, fillColor, width, height) {
  if (icon) {
    // STEP 1: Trim and fix any escaped characters
    icon = icon.trim();

    // Some servers escape forward slashes, which is unnecessary
    icon = icon.replace(/\\\//g, "/");

    // Optional: remove escaped quotes if response is double-encoded
    if (icon.startsWith('"') && icon.endsWith('"')) {
      icon = icon.slice(1, -1);
      icon = icon.replace(/\\"/g, '"');
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(icon, "image/svg+xml");
    const svg = doc.documentElement;

    svg.querySelectorAll("*").forEach((el) => {
      const stroke = el.getAttribute("stroke");
      if (
        el.getAttribute("fill") === "none" ||
        el.getAttribute("fill") === null
      ) {
        el.setAttribute("fill", fillColor);
      }

      if (stroke === "none" || stroke === null) {
        el.setAttribute("stroke", "rgba(0,0,0,0)");
      }
    });

    svg.setAttribute("width", width || "25");
    svg.setAttribute("height", height || "25");

    return svg;
  } else {
    return "";
  }
}

export { getCategoryIcon, updateCategoryIconColor };
